import { type ReactNode, useState } from "react";
import { HeroSectionDataContext, HeroSectionMutatorContext } from "./heroSectionContext";
import { IHeroSectionData } from "./heroSectionContextInterfaces";

interface IProps {
  children: ReactNode;
}

const HeroSectionContextProvider = (props: IProps) => {
  const [heroSectionData, setHeroSectionData] = useState<IHeroSectionData>({
    imagePath: "",
  });

  return (
    <HeroSectionMutatorContext.Provider value={setHeroSectionData}>
      <HeroSectionDataContext.Provider value={heroSectionData}>{props.children}</HeroSectionDataContext.Provider>
    </HeroSectionMutatorContext.Provider>
  );
};

export default HeroSectionContextProvider;
